// src/components/useTables.js
import { useState, useEffect } from "react";
import { toast } from "react-toastify";

export function useLanguages(API_URL) {
  const [languages, setLanguages] = useState([]);

  const fetchLanguages = async () => {
    try {
      const res = await fetch(`${API_URL}/getLanguages`, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      });

      if (!res.ok) throw new Error("Errore durante il recupero delle lingue");

      const data = await res.json();
      setLanguages(data.languages ?? []);
    } catch (err) {
      console.error(err);
      toast.error("Errore durante il caricamento delle lingue");
    }
  };

  useEffect(() => {
    fetchLanguages();
  }, [API_URL]);

  return { languages, fetchLanguages };
}
